import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-star\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,17.45l-5.88,3.6,1.6-6.7L2.49,9.86l6.86-.55L12,3l2.64,6.37,6.87.55-5.23,4.48,1.6,6.7Zm0-2.34,2.82,1.72-.77-3.21,2.51-2.15-3.29-.26L12,8.16l-1.27,3.05-3.29.26L10,13.62l-.77,3.21L12,15.11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol